export default "__VITE_ASSET__DOajwLmy__"